import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IUiTDatabaseOrganizer } from '@internal-models/uit-database.model';

@Injectable({
	providedIn: 'root',
})
export class UiTDatabaseProvider extends Provider<any> {
	protected readonly url: string = '/uit-database';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public searchOrganizerByName(name: string): Promise<Array<IUiTDatabaseOrganizer>> {
		return this.process(this.api.get(`${this.url}/organizers/name?name=${name}`), false) as Promise<
			Array<IUiTDatabaseOrganizer>
		>;
	}

	public createOrganizer(organizer: { name: string; website: string }): Promise<IUiTDatabaseOrganizer> {
		return this.process(
			this.api.post(`${this.url}/organizers`, organizer)
		) as unknown as Promise<IUiTDatabaseOrganizer>;
	}

	public linkOrganizer(organizer: { id: string; name: string; website: string }): Promise<void> {
		return this.process(this.api.put(`${this.url}/organizers/link`, organizer)) as unknown as Promise<void>;
	}

	public unlinkOrganizer(): Promise<void> {
		return this.process(this.api.put(`${this.url}/organizers/unlink`, {})) as unknown as Promise<void>;
	}

	public updateImage(form: FormData): Promise<void> {
		return this.process(this.api.put(`${this.url}/organizers/image`, form, true)) as unknown as Promise<void>;
	}
}
